import React, { Component } from 'react';

import InfoDocument from './InfoDocument';
import {
  setInfoGuidesClicked,
  setDocumentInfo,
} from '../../../analytics/gatherService';

type Props = {
  modelNumber: string,
  omsId: string,
  storeSKU: string,
  documents: Object,
  dataId?: String,
};

class InfoGuides extends Component<Props> {
  constructor() {
    super();

    this.state = {
      isVisible: false,
      styles: {
        top: 0,
        left: 0,
      },
    };
  }

  static onClickDocument(event: Object) {
    const {
      target: { text },
    } = event || { target: { text: '' } };
    setDocumentInfo(text);
  }

  hideToolTip = () => {
    this.setState({
      isVisible: false,
    });
  };

  toggleToolTip = (event: Object) => {
    setInfoGuidesClicked();
    const { isVisible } = this.state;

    // the tooltip will be adjusted to be either on the right or the left
    // the values are dependent on the length of text prior to it (buy again)

    const leftAdjust = event.target.offsetLeft > 90 ? -5 : -90;

    this.setState({
      isVisible: !isVisible,
      styles: {
        top: 15,
        left: leftAdjust,
      },
    });
  };

  render() {
    const { isVisible } = this.state;
    const { styles } = this.state;
    const { omsId, modelNumber, storeSKU, documents, dataId } = this.props;
    const documentArray = documents ? documents.document : null;

    return (
      <div className="infoGuides-inline">
        <span
          aria-hidden
          role="button"
          className="u__default-link"
          onClick={this.toggleToolTip}
          data-automation-id={`infoGuides-${dataId}`}
        >
          Info & Guides
        </span>
        {isVisible && (
          <div style={styles} className="hdReactTooltip">
            <button
              data-automation-id={`infoGuidesButton-${dataId}`}
              type="button"
              className="mw-icon-menu-close tooltip__content__btn--close"
              target="_blank"
              onClick={this.hideToolTip}
            />

            {modelNumber && (
              <p data-automation-id={`infoGuidesModel-${dataId}`}>
                {' '}
                Model {modelNumber}
              </p>
            )}
            {omsId && (
              <p data-automation-id={`infoGuidesInternet-${dataId}`}>
                Internet# {omsId}
              </p>
            )}
            {storeSKU && (
              <p data-automation-id={`infoGuidesSKU-${dataId}`}>
                Store SKU# {storeSKU}
              </p>
            )}
            {documentArray &&
              documentArray.map((document: Object, index: number) => {
                const { name, url } = document;
                return (
                  <InfoDocument
                    onClick={InfoGuides.onClickDocument}
                    key={name}
                    name={name}
                    url={url}
                    dataId={dataId}
                    index={index}
                  />
                );
              })}
          </div>
        )}
      </div>
    );
  }
}

InfoGuides.defaultProps = {
  dataId: '',
};

export default InfoGuides;
